import { IUser } from "../../types/user";
import authApi from "../../utils/AxiosConfig";
import authHeader from "../../utils/authHeader";

const updateUser = async (userData: Partial<IUser>, token: string) => {
    const response = await authApi.put("/user/new-user-profile-update", userData, {
        headers: authHeader(token),
    });
    return response.data;
};

const userService = {
    updateUser,
};

export default userService;
